import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      const { fallbackMessage = 'Something went wrong.' } = this.props;
      return (
        <div className="flex flex-col items-center justify-center p-8 text-center" style={{ color: 'var(--ui-text2, #6b7280)' }}>
          <p className="text-sm mb-2">{fallbackMessage}</p>
          {this.state.error && (
            <p className="text-xs mb-4 font-mono opacity-60">
              {this.state.error.message}
            </p>
          )}
          <button
            onClick={this.handleReset}
            className="text-xs px-3 py-1 border rounded"
            style={{ borderColor: 'var(--ui-border, #e5e7eb)', color: 'var(--ui-text, #000)' }}
          >
            Try again
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}
